import { useLayoutEffect, useRef } from "react";

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const userNameRegex = /^[a-zA-Z0-9_.-]*$/;
export const nameRegex = /^[a-zA-Z0-9_\\.\-\s]*$/;
// export const websiteRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+)\.([a-z]{2,})(\/\S*)?(\?\S*)?$/;
export const websiteRegex = /^((http(s?)?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/g;

export const useWillMountHook = (callback) => {
  const didMount = useRef(false);

  useLayoutEffect(() => {
    if (callback && !didMount.current) {
      didMount.current = true;
      callback();
    }
  }, [callback]);
};
